import React from "react";
import SettingComponent from "../../../components/Settings/Settings";
import DashboardTopSearch from "../../../components/DashboardTopSearch/DashboardTopSearch";
import { useNavigate } from "react-router-dom";

const Settings = () => {
  const navigate = useNavigate();
  
    const goBack = () => {
      navigate(-1);
    };
  return (
    <>
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <h3
              className="ah-heading-04 fw-bold me-29 mb-0 d-flex align-items-center gap-3 cursor-pointer"
              onClick={goBack}
            >
              <span aria-label="Back to courses">
                <span className="icon-arrow-left"></span>
              </span>
              Settings
            </h3>
          </div>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <DashboardTopSearch />
            <span className="icon-bell notification-bell theme-color  cursor-pointer"></span>
          </div>
        </div>
      </div>
      <SettingComponent userRole="student" />
    </>
  );
};

export default Settings;
